// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"69d2a576","383":"c21aee22"}[chunkId] + ".chunk.css";
};